import type { ReactElement } from "react";
import { Box, Dialog, DialogTitle, DialogContent, DialogContentText, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, DialogActions, Button } from "@mui/material";
import Scrollbar from "src/components/scrollbar";
import { Transition } from "src/shorts/Transition";

export type ConfirmModalProps = {
  onAction: VoidFunction;
  title?: string;
  rows: any[];
  cols: string[];
  onClose: VoidFunction;
};

export const CONFIRM_MODAL = 'CONFIRM_MODAL';

export const ConfirmModal = ({
  onAction,
  title,
  rows,
  cols,
  onClose,
}: ConfirmModalProps): ReactElement => (
    <Dialog
      open
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="alert-dialog-slide-title">{title || 'Do you want to continue?'}</DialogTitle>

      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          <Box mb={1}>The action will be applied to the following {rows.length} documents:</Box>
          <Scrollbar sx={{ maxHeight: '200px' }}>
            <TableContainer component={Paper}>
              <Table stickyHeader aria-label="simple table" size="small">
                <TableHead>
                  <TableRow>
                    {cols.map((colName, index) => (
                      <TableCell key={index}>{colName}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row, index) => (
                    <TableRow
                      key={index}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      {cols.map((colName, index) => (
                        <TableCell key={index}>{row[colName]}</TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button color="inherit" onClick={onClose}>
          Cancel
        </Button>

        <Button variant="contained" onClick={onAction}>
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  )
